import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FiltersCard = styled.section`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  h3 {
    margin: 0;
    color: #0c5c75;
    font-weight: 600;
  }
`;

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;

  button.clearButton {
    border-radius: 8px;
    padding: 10px 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: 2px solid #0c5c75;
    background: transparent;
    color: #0c5c75;
    transition: background 0.2s ease, opacity 0.2s ease;
  }

  button.clearButton:hover:not(:disabled) {
    background: rgba(12, 92, 117, 0.1);
  }

  button.clearButton:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ResultsCard = styled.section`
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;

  th {
    text-align: left;
    font-weight: 600;
    color: #0c5c75;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba(12, 92, 117, 0.2);
  }

  td {
    padding: 14px 0;
    border-bottom: 1px solid rgba(12, 92, 117, 0.1);
    color: #173f4d;
  }

  tbody tr:last-of-type td {
    border-bottom: none;
  }
`;

export const TypeTag = styled.span<{ variant: 'sensor' | 'battery' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #ffffff;
  background: ${props => (props.variant === 'sensor' ? '#0c5c75' : '#ff7a00')};
`;

export const ReadBadge = styled.span<{ read: boolean }>`
  font-weight: 600;
  color: ${props => (props.read ? '#0c5c75' : '#c0392b')};
`;

export const MarkReadButton = styled.button`
  border-radius: 8px;
  padding: 6px 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border: 2px solid #0c5c75;
  background: transparent;
  color: #0c5c75;
  transition: background 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    background: rgba(12, 92, 117, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Message = styled.p`
  margin: 0;
  color: #0c5c75;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 32px 0;
  color: #4a5c64;
  font-weight: 500;
`;

export const LoadingState = styled.div`
  text-align: center;
  padding: 32px 0;
  color: #0c5c75;
  font-weight: 600;
`;

export const PaginationBar = styled.div`
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  color: #0c5c75;
`;

export const PaginationInfo = styled.div`
  font-weight: 500;
`;

export const PaginationActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;

  .nav {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  span {
    font-weight: 600;
  }
`;

export const PageSizeControl = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
`;

export const PageSizeSelect = styled.select`
  border: 1px solid rgba(12, 92, 117, 0.3);
  border-radius: 8px;
  background: #f3f9fb;
  padding: 6px 10px;
  color: #0c5c75;
  font-weight: 600;
`;

export const PaginationButton = styled.button`
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 2px solid #0c5c75;
  background: transparent;
  color: #0c5c75;
  transition: background 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    background: rgba(12, 92, 117, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
